import {
  REDIRECT_DONE, REDIRECT_INIT, UPDATE_BLOCK_ROUTING, NOTIFY_USER_ROUTE_BLOCKED, USER_CONFIRMS_TO_CHANGE_ROUTE,
} from '../actions/types/redirectActionTypes';
import { AUTH_LOGOUT } from '../actions/types/authActionTypes';

const initialState = {
  status: 'DONE',
  url: '',
  blockRouting: false,
  showConfirmationDialog: false,
  userConfirmed: false,
};

export const redirectReducer = (state = initialState, action) => {
  switch (action.type) {
  case REDIRECT_INIT:
    return {
      status: 'INIT',
      url: action.payload,
    };
  case UPDATE_BLOCK_ROUTING:
    return {
      ...state,
      blockRouting: action.payload,
    };
  case NOTIFY_USER_ROUTE_BLOCKED:
    return {
      ...state,
      showConfirmationDialog: action.payload,
    };
  case USER_CONFIRMS_TO_CHANGE_ROUTE:
    return {
      ...state,
      userConfirmed: action.payload,
    };
  case REDIRECT_DONE:
    return {
      ...initialState,
      blockRouting: state.blockRouting,
      showConfirmationDialog: state.showConfirmationDialog,
      userConfirmed: state.userConfirmed,
    };
  case AUTH_LOGOUT:
    return initialState;
    // Add your own action types here if redirect is needed
  default:
    return state;
  }
};
